<template>
  <div class="content">

    <div class="container-fluid">

      <!-- FILTERS -->
      <div class="row">
        <div class="col-12">

          <div class="card">

            <div class="card-header card-header-primary">
              <h4 class="card-title">
                Voucher Dashboard
              </h4>

              <p class="card-category">
                Invoice and voucher financial summary
              </p>
            </div>

            <div class="card-body">

              <div class="row">

                <!-- Start Date -->
                <div class="col-lg-2 col-md-4 col-sm-6">
                  <div class="form-group">

                    <label>
                      Start Date
                    </label>

                    <input
                        v-model="filters.start_date"
                        type="date"
                        class="form-control"
                    >

                  </div>
                </div>


                <!-- End Date -->
                <div class="col-lg-2 col-md-4 col-sm-6">
                  <div class="form-group">

                    <label>
                      End Date
                    </label>

                    <input
                        v-model="filters.end_date"
                        type="date"
                        class="form-control"
                    >

                  </div>
                </div>


                <!-- Station -->
                <div class="col-lg-2 col-md-4 col-sm-6">
                  <div class="form-group">

                    <label>
                      Station
                    </label>

                    <select
                        v-model="filters.station_id"
                        class="form-control"
                    >

                      <option value="">
                        All Stations
                      </option>

                      <option
                          v-for="station in stations"
                          :key="station.id"
                          :value="station.id"
                      >
                        {{ station.name }}
                      </option>

                    </select>

                  </div>
                </div>


                <!-- Department -->
                <div class="col-lg-2 col-md-4 col-sm-6">
                  <div class="form-group">

                    <label>
                      Department
                    </label>

                    <select
                        v-model="filters.department_id"
                        class="form-control"
                    >

                      <option value="">
                        All Departments
                      </option>

                      <option
                          v-for="department in departments"
                          :key="department.id"
                          :value="department.id"
                      >
                        {{ department.name }}
                      </option>

                    </select>

                  </div>
                </div>


                <!-- Vendor -->
                <div class="col-lg-2 col-md-4 col-sm-6">
                  <div class="form-group">

                    <label>
                      Vendor
                    </label>

                    <select
                        v-model="filters.vendor_id"
                        class="form-control"
                    >

                      <option value="">
                        All Vendors
                      </option>

                      <option
                          v-for="vendor in vendors"
                          :key="vendor.id"
                          :value="vendor.id"
                      >
                        {{ vendor.name }}
                      </option>

                    </select>

                  </div>
                </div>


                <!-- Buttons -->
                <div class="col-lg-2 col-md-4 col-sm-6">

                  <div class="filter-buttons">

                    <button
                        type="button"
                        class="btn btn-primary"
                        :disabled="dashboardLoading"
                        @click="loadDashboard"
                    >
                      <i class="material-icons">
                        search
                      </i>
                      Apply
                    </button>

                    <button
                        type="button"
                        class="btn btn-default"
                        :disabled="dashboardLoading"
                        @click="resetFilters"
                    >
                      <i class="material-icons">
                        refresh
                      </i>
                      Reset
                    </button>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>
      </div>


      <!-- KPI CARDS -->
      <div class="row">

        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="card card-stats">

            <div class="card-header card-header-primary card-header-icon">

              <div class="card-icon">
                <i class="material-icons">
                  receipt_long
                </i>
              </div>

              <p class="card-category">
                Total Invoices
              </p>

              <h3 class="card-title">
                {{ number(invoiceSummary.total_invoices) }}
              </h3>

            </div>

            <div class="card-footer">
              <div class="stats">
                <i class="material-icons">description</i>
                Invoice records
              </div>
            </div>

          </div>
        </div>


        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="card card-stats">

            <div class="card-header card-header-success card-header-icon">

              <div class="card-icon">
                <i class="material-icons">
                  request_quote
                </i>
              </div>

              <p class="card-category">
                Total Vouchers
              </p>

              <h3 class="card-title">
                {{ number(voucherSummary.total_vouchers) }}
              </h3>

            </div>

            <div class="card-footer">
              <div class="stats">
                <i class="material-icons">receipt</i>
                Voucher records
              </div>
            </div>

          </div>
        </div>


        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="card card-stats">

            <div class="card-header card-header-warning card-header-icon">

              <div class="card-icon">
                <i class="material-icons">
                  payments
                </i>
              </div>

              <p class="card-category">
                Gross Pay
              </p>

              <h3 class="card-title">
                {{ money(voucherSummary.gross_pay) }}
              </h3>

            </div>

            <div class="card-footer">
              <div class="stats">
                <i class="material-icons">account_balance</i>
                Total gross amount
              </div>
            </div>

          </div>
        </div>


        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="card card-stats">

            <div class="card-header card-header-danger card-header-icon">

              <div class="card-icon">
                <i class="material-icons">
                  account_balance_wallet
                </i>
              </div>

              <p class="card-category">
                Payable
              </p>

              <h3 class="card-title">
                {{ money(voucherSummary.payable) }}
              </h3>

            </div>

            <div class="card-footer">
              <div class="stats">
                <i class="material-icons">payments</i>
                Total payable
              </div>
            </div>

          </div>
        </div>

      </div>


      <!-- SECOND KPI ROW -->
      <div class="row">

        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="card card-stats">

            <div class="card-header card-header-info card-header-icon">

              <div class="card-icon">
                <i class="material-icons">
                  attach_money
                </i>
              </div>

              <p class="card-category">
                Invoice Gross
              </p>

              <h3 class="card-title">
                {{ money(invoiceSummary.gross_amount) }}
              </h3>

            </div>

          </div>
        </div>


        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="card card-stats">

            <div class="card-header card-header-primary card-header-icon">

              <div class="card-icon">
                <i class="material-icons">
                  account_balance
                </i>
              </div>

              <p class="card-category">
                VAT
              </p>

              <h3 class="card-title">
                {{ money(invoiceSummary.vat) }}
              </h3>

            </div>

          </div>
        </div>


        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="card card-stats">

            <div class="card-header card-header-success card-header-icon">

              <div class="card-icon">
                <i class="material-icons">
                  check_circle
                </i>
              </div>

              <p class="card-category">
                Paid
              </p>

              <h3 class="card-title">
                {{ money(invoiceSummary.paid_amount) }}
              </h3>

            </div>

          </div>
        </div>


        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="card card-stats">

            <div class="card-header card-header-danger card-header-icon">

              <div class="card-icon">
                <i class="material-icons">
                  pending
                </i>
              </div>

              <p class="card-category">
                Outstanding
              </p>

              <h3 class="card-title">
                {{ money(invoiceSummary.outstanding_amount) }}
              </h3>

            </div>

          </div>
        </div>

      </div>


      <!-- STATUS -->
      <div class="row">

        <div class="col-12">

          <div class="card">

            <div class="card-header card-header-primary">
              <h4 class="card-title">
                Invoice Status
              </h4>

              <p class="card-category">
                Current invoice status distribution
              </p>
            </div>

            <div class="card-body">

              <div class="row">

                <div
                    v-for="status in statuses"
                    :key="status.status"
                    class="col-lg-3 col-md-4 col-sm-6"
                >

                  <div class="status-material-card">

                    <div class="status-number">
                      {{ number(status.total) }}
                    </div>

                    <div class="status-label">
                      {{ status.status }}
                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>


      <!-- STATION -->
      <div class="row">

        <!-- Chart -->
        <div class="col-lg-5 col-md-12">

          <div class="card">

            <div class="card-header card-header-info">
              <h4 class="card-title">
                Labourers by Station
              </h4>

              <p class="card-category">
                Labourer distribution
              </p>
            </div>

            <div class="card-body chart-body">

              <canvas ref="stationChart"></canvas>

            </div>

          </div>

        </div>


        <!-- Table -->
        <div class="col-lg-7 col-md-12">

          <div class="card">

            <div class="card-header card-header-primary">
              <h4 class="card-title">
                Station Summary
              </h4>
            </div>

            <div class="card-body table-responsive">

              <table class="table">

                <thead class="text-primary">
                <tr>
                  <th>Station</th>
                  <th class="text-right">Invoices</th>
                  <th class="text-right">Amount</th>
                  <th class="text-right">Labourers</th>
                </tr>
                </thead>

                <tbody>

                <tr
                    v-for="station in stationSummary"
                    :key="station.id"
                >

                  <td>
                    {{ station.name }}
                  </td>

                  <td class="text-right">
                    {{ number(station.invoices) }}
                  </td>

                  <td class="text-right">
                    {{ money(station.item_amount) }}
                  </td>

                  <td class="text-right">
                    {{ number(station.labourer_count) }}
                  </td>

                </tr>

                </tbody>

              </table>

            </div>

          </div>

        </div>

      </div>


      <!-- DEPARTMENT -->
      <div class="row">

        <div class="col-lg-7 col-md-12">

          <div class="card">

            <div class="card-header card-header-warning">
              <h4 class="card-title">
                Amount by Department
              </h4>

              <p class="card-category">
                Invoice amount distribution
              </p>
            </div>

            <div class="card-body department-chart-body">

              <canvas ref="departmentChart"></canvas>

            </div>

          </div>

        </div>


        <div class="col-lg-5 col-md-12">

          <div class="card">

            <div class="card-header card-header-primary">
              <h4 class="card-title">
                Department Summary
              </h4>
            </div>

            <div class="card-body table-responsive">

              <table class="table">

                <thead class="text-primary">

                <tr>
                  <th>Department</th>
                  <th class="text-right">Invoices</th>
                  <th class="text-right">Amount</th>
                  <th class="text-right">VAT</th>
                </tr>

                </thead>

                <tbody>

                <tr
                    v-for="item in departmentSummary"
                    :key="item.department_id"
                >

                  <td>
                    {{
                      item.department
                          ? item.department.name
                          : 'Unknown'
                    }}
                  </td>

                  <td class="text-right">
                    {{ number(item.invoices) }}
                  </td>

                  <td class="text-right">
                    {{ money(item.amount) }}
                  </td>

                  <td class="text-right">
                    {{ money(item.vat) }}
                  </td>

                </tr>

                </tbody>

              </table>

            </div>

          </div>

        </div>

      </div>


      <!-- VENDOR -->
      <div class="row">

        <div class="col-lg-5 col-md-12">

          <div class="card">

            <div class="card-header card-header-success">
              <h4 class="card-title">
                Amount by Vendor
              </h4>

              <p class="card-category">
                Invoice distribution by vendor
              </p>
            </div>

            <div class="card-body vendor-chart-body">

              <canvas ref="vendorChart"></canvas>

            </div>

          </div>

        </div>


        <div class="col-lg-7 col-md-12">

          <div class="card">

            <div class="card-header card-header-primary">
              <h4 class="card-title">
                Vendor Summary
              </h4>
            </div>

            <div class="card-body table-responsive">

              <table class="table">

                <thead class="text-primary">

                <tr>
                  <th>Vendor</th>
                  <th class="text-right">Invoices</th>
                  <th class="text-right">Amount</th>
                  <th class="text-right">VAT</th>
                </tr>

                </thead>

                <tbody>

                <tr
                    v-for="item in vendorSummary"
                    :key="item.vendor_id"
                >

                  <td>
                    {{
                      item.vendor
                          ? item.vendor.name
                          : 'Unknown'
                    }}
                  </td>

                  <td class="text-right">
                    {{ number(item.invoices) }}
                  </td>

                  <td class="text-right">
                    {{ money(item.amount) }}
                  </td>

                  <td class="text-right">
                    {{ money(item.vat) }}
                  </td>

                </tr>

                </tbody>

              </table>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import {
  Chart,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  DoughnutController,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

Chart.register(
    BarController,
    BarElement,
    CategoryScale,
    LinearScale,
    DoughnutController,
    ArcElement,
    Tooltip,
    Legend
);
export default {

  name: 'VoucherDashboardPage',

  data() {
    return {

      filters: {
        start_date: '',
        end_date: '',
        station_id: '',
        department_id: '',
        vendor_id: ''
      },

      stations: [],
      departments: [],
      vendors: [],

      stationChart: null,
      departmentChart: null,
      vendorChart: null
    };
  },

  computed: {

    ...mapState('vouchers', [
      'dashboard',
      'dashboardLoading',
      'dashboardError'
    ]),

    invoiceSummary() {
      return (
          this.dashboard &&
          this.dashboard.summary &&
          this.dashboard.summary.invoice
      ) || {};
    },

    voucherSummary() {
      return (
          this.dashboard &&
          this.dashboard.summary &&
          this.dashboard.summary.voucher
      ) || {};
    },

    statuses() {
      return this.dashboard.statuses || [];
    },

    stationSummary() {
      return this.dashboard.stations || [];
    },

    departmentSummary() {
      return this.dashboard.departments || [];
    },

    vendorSummary() {
      return this.dashboard.vendors || [];
    }
  },

  created() {
    this.loadDashboard();
  },
  beforeDestroy() {
    if (this.stationChart) {
      this.stationChart.destroy();
      this.stationChart = null;
    }

    if (this.departmentChart) {
      this.departmentChart.destroy();
      this.departmentChart = null;
    }

    if (this.vendorChart) {
      this.vendorChart.destroy();
      this.vendorChart = null;
    }
  },

  methods: {

    ...mapActions('vouchers', [
      'fetchDashboard'
    ]),

    async loadDashboard() {

      try {

        const filters = {
          ...this.filters
        };

        Object.keys(filters).forEach(key => {

          if (
              filters[key] === '' ||
              filters[key] === null ||
              typeof filters[key] === 'undefined'
          ) {
            delete filters[key];
          }

        });

        const response = await this.fetchDashboard(
            filters
        );

        this.stations = response.stations || [];

        this.departments = (
            response.departments || []
        ).map(item => item.department);

        this.vendors = (
            response.vendors || []
        ).map(item => item.vendor);

        await this.$nextTick();

        this.renderCharts();

      } catch (error) {

        console.error(
            'Failed to load voucher dashboard:',
            error
        );
      }
    },

    resetFilters() {

      this.filters = {
        start_date: '',
        end_date: '',
        station_id: '',
        department_id: '',
        vendor_id: ''
      };

      this.loadDashboard();
    },

    money(value) {

      const amount = Number(value || 0);

      return new Intl.NumberFormat(
          'en-TZ',
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
      ).format(amount);
    },

    number(value) {

      return new Intl.NumberFormat(
          'en-TZ'
      ).format(
          Number(value || 0)
      );
    },
    renderCharts() {

      this.renderStationChart();

      this.renderDepartmentChart();

      this.renderVendorChart();
    },
    renderStationChart() {

      if (this.stationChart) {
        this.stationChart.destroy();
      }

      const canvas = this.$refs.stationChart;

      if (!canvas) {
        return;
      }

      const labels = this.stationSummary.map(
          station => station.name
      );

      const values = this.stationSummary.map(
          station => Number(
              station.labourer_count || 0
          )
      );

      this.stationChart = new Chart(
          canvas.getContext('2d'),
          {
            type: 'bar',

            data: {
              labels,

              datasets: [
                {
                  label: 'Labourers',
                  data: values
                }
              ]
            },

            options: {
              responsive: true,

              maintainAspectRatio: false,

              plugins: {
                legend: {
                  display: false
                }
              },

              scales: {
                y: {
                  beginAtZero: true
                }
              }
            }
          }
      );
    },
    renderDepartmentChart() {

      if (this.departmentChart) {
        this.departmentChart.destroy();
        this.departmentChart = null;
      }

      const canvas = this.$refs.departmentChart;

      if (!canvas) {
        return;
      }

      const labels = this.departmentSummary.map(
          department => {
            return department.department
                ? department.department.name
                : 'Unknown';
          }
      );

      const values = this.departmentSummary.map(
          department => {
            return Number(
                department.amount || 0
            );
          }
      );

      this.departmentChart = new Chart(
          canvas.getContext('2d'),
          {
            type: 'bar',

            data: {
              labels: labels,

              datasets: [
                {
                  label: 'Amount',
                  data: values
                }
              ]
            },

            options: {

              /*
               * Chart.js 3 replacement for
               * type: horizontalBar
               */
              indexAxis: 'y',

              responsive: true,

              maintainAspectRatio: false,

              plugins: {

                legend: {
                  display: false
                },

                tooltip: {
                  callbacks: {

                    label: (context) => {

                      return this.money(
                          context.raw
                      );

                    }

                  }
                }

              },

              scales: {

                /*
                 * Chart.js 3
                 * NOT xAxes
                 */
                x: {

                  beginAtZero: true,

                  ticks: {

                    callback: (value) => {

                      return this.formatCompactAmount(
                          value
                      );

                    }

                  }

                },

                /*
                 * Chart.js 3
                 * NOT yAxes
                 */
                y: {

                  ticks: {

                    autoSkip: false

                  }

                }

              }

            }

          }
      );
    },
    renderVendorChart() {

      if (this.vendorChart) {
        this.vendorChart.destroy();
        this.vendorChart = null;
      }

      const canvas = this.$refs.vendorChart;

      if (!canvas) {
        return;
      }

      const labels = this.vendorSummary.map(
          vendor =>
              vendor.vendor
                  ? vendor.vendor.name
                  : 'Unknown'
      );

      const values = this.vendorSummary.map(
          vendor =>
              Number(vendor.amount || 0)
      );

      this.vendorChart = new Chart(
          canvas.getContext('2d'),
          {
            type: 'doughnut',

            data: {
              labels: labels,

              datasets: [
                {
                  data: values
                }
              ]
            },

            options: {

              responsive: true,

              maintainAspectRatio: false,

              plugins: {

                legend: {
                  position: 'bottom'
                },

                tooltip: {

                  callbacks: {

                    label: (context) => {

                      const label =
                          context.label || '';

                      const value =
                          context.raw || 0;

                      return `${label}: ${this.money(value)}`;
                    }

                  }

                }

              }

            }

          }
      );
    },
    formatCompactAmount(value) {

      value = Number(value || 0);

      if (value >= 1000000000) {
        return (
            (value / 1000000000)
                .toFixed(1) + 'B'
        );
      }

      if (value >= 1000000) {
        return (
            (value / 1000000)
                .toFixed(1) + 'M'
        );
      }

      if (value >= 1000) {
        return (
            (value / 1000)
                .toFixed(1) + 'K'
        );
      }

      return value;
    },
  }
};
</script>
<style scoped>

.chart-body {
  position: relative;
  height: 330px;
}

.department-chart-body {
  position: relative;
  height: 450px;
}

.vendor-chart-body {
  position: relative;
  height: 330px;
}

.status-material-card {
  padding: 20px;
  margin-bottom: 10px;
  text-align: center;
  border-radius: 4px;
  background: #f8f9fa;
}

.status-number {
  font-size: 28px;
  font-weight: 600;
}

.status-label {
  margin-top: 6px;
  font-size: 13px;
  text-transform: uppercase;
  color: #777;
}

.card-stats {
  margin-bottom: 30px;
}

.card-stats .card-title {
  font-size: 20px;
}

.table td,
.table th {
  vertical-align: middle;
}

</style>
